@if(loader){
<app-loader></app-loader>
}
<p-card>
    <form [formGroup]="createProductForm">
        <div class="grid mb">
            <div class="col">
                <p-button label="Update" severity="info" (click)="updateProduct()" icon="pi pi-arrow-circle-up"
                    size="small"></p-button><br>
                <br>
            <div class="field text-left">
                    <label for="IsServiceType" class="label-required display">Type</label>
                     <div style="display: flex; gap: 1rem; align-items: center;">
                       <label>
                        <input type="radio" formControlName="IsServiceType"[value]="false"(change)="onTypeChange()" />Goods</label>

                    <label>
                        <input type="radio" formControlName="IsServiceType" [value]="true" (change)="onTypeChange()" /> Service
                    </label>
                    </div>

                    <!-- <div *ngIf="createProductForm.get('IsServiceType')?.invalid && createProductForm.get('IsServiceType')?.touched"
                        style="color: red;">
                        Please select a type (Goods or Service).
                    </div> -->
                    <small *ngIf="submitted && formControls.IsServiceType.errors" id="name-error" class="text-red-500">
                        Please select a type (Goods or Service).</small>
                </div>

                <div class="field">
                    <label for="website">Product Code</label>
                    <div class="flex align-items-center">
                        <input pInputText type="text" readonly formControlName="ProductCode" />
                    </div>
                </div>

                <div class="field text-left">
                    <label for="website" style="margin-top: 10px;">Product Name</label>
                    <input pInputText placeholder="e.g Iphone 15 Pro" formControlName="ProductName"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ProductName.errors }"
                        class="w-full p-inputtext-sm" />
                    <small *ngIf="submitted && formControls.ProductName.errors" id="name-error"
                        class="text-red-500">Required
                        field.</small>
                </div>


                <div class="field text-left" style="margin-top: 0px;">
                    <label for="website">Product Specification / Grade</label>
                    <input pInputText formControlName="ProductSpecification" class="w-full p-inputtext-sm" />
                </div>
            </div>
            <div class="col">
                <div class="flex align-items-center mt-5" style="margin-top: 20px; display: flex; gap: 10px;">
                    <div class="flex align-items-center">
                        <p-checkbox label="Active" formControlName="isactive" [binary]="true"></p-checkbox>
                    </div>
                    <div class="flex align-items-center">
                        <p-checkbox label="Taxable" formControlName="IsTaxable" value="true"
                            [readonly]="iseditProduct || !iseditProduct" [binary]="true"></p-checkbox>
                    </div>
                    <div class="flex align-items-center">
                        <p-checkbox label="Inventory" formControlName="IsInventory" [binary]="true"
                            value="true"></p-checkbox>
                    </div>
                </div><br>
                <!-- <div class="flex align-items-center pd1">
                    <div class="flex align-items-center">
                        <p-checkbox label="Can be Purchased" formControlName="CanBePurchased" [binary]="true" value="true" ></p-checkbox>
                    </div>
                    <div class="flex align-items-center">
                        <p-checkbox formControlName="CanBeSold" [binary]="true" label="Can be Sold" value="true" ></p-checkbox>
                    </div>
                    <div class="flex align-items-center">
                        <p-checkbox label="Can be Rented" formControlName="CanBeRented" [binary]="true" value="true" ></p-checkbox>
                    </div>
                </div><br> -->
                <div class="flex align-items-center" style="margin-top: 1px;">
                    <div class="flex align-items-center">
                        <p-checkbox label="Lot Controlled" formControlName="isLotTracking" [binary]="true"
                            value="true"></p-checkbox>
                    </div>
                    <div class="flex align-items-center">
                        <p-checkbox label="Inventory By Location?" formControlName="isLocationTracking" [binary]="true"
                            value="true"></p-checkbox>
                    </div>
                    <div class="flex align-items-center">
                        <p-checkbox label="Serial Tracking" formControlName="isSerialTracking" [binary]="true"
                            value="true"></p-checkbox>
                    </div>
                </div>

                <div class="field mt-1" style="display: flex; gap: 10px;">
                    <div class="field text-left" style="flex: 1;">
                        <label for="tags" class="bold-label" style="margin-top: 5px;">Product Size</label>
                        <input formControlName="ProductSize" pInputText placeholder="" class="input-field" />
                    </div>

                    <div class="field text-left" style="flex: 1;">
                        <label for="Weight" style="margin-top: 5px;">Weight</label>
                        <input pInputText formControlName="Weight" class="w-full p-inputtext-sm"
                            style="height: 40px; padding: 5px;" />
                    </div>
                </div>

                <div class="field mt-0">
                    <label for="website">Product Description</label>
                    <input pInputText formControlName="ProductDescription" placeholder="e.g Powerfull iPhone innovation"
                        class="w-full p-inputtext-sm" />
                </div>

            </div>

            <div class="col">
                <div class="field text-left">
                    <div class="flex justify-content-center">
                        <input type="file" (change)="onFileSelected($event)" #fileInput style="display: none"
                            accept="image/png, image/jpeg">

                        @if (previewImage) {
                        <div style="border: 2px solid; border-radius: 10px; position: relative; object-fit: fill;">
                            <p-image [src]="previewImage" alt="Image" width="150px" height="140"
                                [preview]="true"></p-image>
                        </div>
                        } @else {
                        <label for="fileInput" style="cursor: pointer;" (click)="fileInput.click()">
                            <img src="./assets/upload-logo.jpg" width="100px" alt="Image"
                                style="border: 2px solid; border-radius: 10px; position: static;">
                        </label>
                        }
                        @if (previewImage) {
                        <div class="flex justify-content mt-2" style="align-items:center ;">
                            <p-button class="p-button-outlined ml-2 " severity="danger" icon="pi pi-trash" size="small"
                                (click)="deleteImage()"></p-button>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
        <br>


        <p-tabView [(activeIndex)]="activeIndex">
            <p-tabPanel header="General Information">
                <div class="grid">
                    <div class="col">
                        <div class="field text-left custom-width">
                            <label for="producttypedropdown">Product Type</label>
                            <p-autoComplete formControlName="producttypedropdown" [dropdown]="!iseditProduct"
                                (onSelect)="setProductType($event)" (completeMethod)="filterProductType($event)"
                                [suggestions]="filterproducttype" field="productTypeName" styleClass="w-full"
                                placeholder="Select Product Type" (keydown)="$event.preventDefault()"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ProductType.errors}">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.productTypeCode}} - {{item.productTypeName}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <small *ngIf="submitted && formControls.ProductType.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>

                        <div class="field text-left custom-width" *ngIf="hide">
                            <label for="UOM">Stocking UOM</label>
                            <p-autoComplete formControlName="UOM" [dropdown]="true" (onSelect)="setUOM($event)"
                                [suggestions]="filteruom" (completeMethod)="filterUOM($event)" field="unitsofMeasure"
                                placeholder="Search UOM" styleClass="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && !this.createProductForm.controls.UnitsOfMeasure.value}">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.unitsofMeasureCode}} - {{item.unitsofMeasure}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <small *ngIf="submitted && formControls.UnitsOfMeasure.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>

                        <div class="field text-left custom-width" *ngIf="hide">
                            <label for="website">Purchase UOM</label>
                            <p-autoComplete formControlName="PurchasingUom" [dropdown]="true"
                                (onSelect)="setPurchasingUOM($event)" [suggestions]="filteruom"
                                (completeMethod)="filterUOM($event)" field="unitsofMeasure" placeholder="Search UOM"
                                styleClass="w-full">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.unitsofMeasureCode}} - {{item.unitsofMeasure}}</span>
                                </ng-template>
                            </p-autoComplete>
                        </div>

                        <div class="field text-left custom-width" *ngIf="hide">
                            <label for="website">Selling UOM</label>
                            <p-autoComplete formControlName="SellingUom" [dropdown]="true"
                                (onSelect)="setSellingUOM($event)" [suggestions]="filteruom"
                                (completeMethod)="filterUOM($event)" field="unitsofMeasure" placeholder="Search UOM"
                                styleClass="w-full">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.unitsofMeasureCode}} - {{item.unitsofMeasure}}</span>
                                </ng-template>
                            </p-autoComplete>
                        </div>
                        <div class="field text-left custom-width" *ngIf="!hide">
                            <label for="tags">Purchase Cost</label>
                            <input formControlName="StandardCost" type="number" pInputText placeholder="" class="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.StandardCost.errors}" />
                            <small *ngIf="submitted && formControls.StandardCost.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                        <div class="field text-left custom-width" *ngIf="!hide">
                            <label for="tags">Sales Price</label>
                            <input formControlName="SalesPrice" type="number" pInputText placeholder=""
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.SalesPrice.errors}"
                                class="w-full" />
                            <small *ngIf="submitted && formControls.SalesPrice.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>

                        <!-- <div class="field text-left mt-4 custom-width" *ngIf="!hide">
                        <label for="tags">Colour</label>
                         <p-autoComplete formControlName="ColorId" [dropdown]="true" (onSelect)="setColor($event)"
                                                    (completeMethod)="filterColor($event)" [suggestions]="filtercolor" field="colorName"
                                                    placeholder="Select color" styleClass="w-full"
                                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ColorId.errors}">
                                                    <ng-template let-item pTemplate="item">
                                                        <span>{{ item.colorName }}</span>
                                                    </ng-template>
                                                </p-autoComplete> 
                    
                    
                        <p-autoComplete formControlName="Color" [suggestions]="filteredColors" (completeMethod)="filterColors($event)"
                            field="colorName" [minLength]="1" placeholder="Select a color" [dropdown]="true" styleClass="w-full"
                            [forceSelection]="true"></p-autoComplete>
                    </div> -->

                        <div class="field-group"
                            style="display: flex; justify-content: space-between; gap: 10px; margin-top: 8px;">
                            <div class="field text-left mt-1" style="margin-top: 0;">
                                <label for="hsnCode">HSN/SAC Code</label>
                                <div style="display: flex; align-items: center;">
                                    <input pInputText readonly (click)="getGSTList()" class="w-full p-inputtext-sm"
                                        formControlName="HSNCode"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && !this.createProductForm.controls.HSNCode.value}"
                                        style="height: 28px;" />
                                    <div style="margin-left: 8px;">
                                        <p-button icon="pi pi-search" (click)="getGSTList()" [raised]="true"
                                            [size]="'small'" severity="info"></p-button>
                                    </div>
                                </div>
                            </div>
                            <div class="field text-left mt-1" style="margin-top: 0;">
                                <label for="gstRate">GST Rate (%)</label>
                                <div style="display: flex; align-items: center;">
                                    <input pInputText type="text" class="w-full p-inputtext-sm"
                                        formControlName="gstRate" readonly placeholder="GST Rate"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && !this.createProductForm.controls.gstRate.value}"
                                        style="height: 28px;" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col">
                        <div class="field text-left custom-width" *ngIf="hide">
                            <label for="tags">Sales Price</label>
                            <input formControlName="SalesPrice" type="number" pInputText placeholder=""
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.SalesPrice.errors}"
                                class="w-full" />
                            <small *ngIf="submitted && formControls.SalesPrice.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                        <div class="field text-left custom-width" *ngIf="hide">
                            <label for="tags">Purchase Cost</label>
                            <input formControlName="StandardCost" type="number" pInputText placeholder="" class="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.StandardCost.errors}" />
                            <small *ngIf="submitted && formControls.StandardCost.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>

                        <div class="field text-left custom-width" *ngIf="!hide">
                            <label for="UOM"> UOM</label>
                            <p-autoComplete formControlName="UOM" [dropdown]="true" (onSelect)="setUOM($event)"
                                [suggestions]="filteruom" (completeMethod)="filterUOM($event)" field="unitsofMeasure"
                                placeholder="Search UOM" styleClass="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && !this.createProductForm.controls.UnitsOfMeasure.value}">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.unitsofMeasureCode}} - {{item.unitsofMeasure}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <small *ngIf="submitted && formControls.UnitsOfMeasure.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                        <div class="field text-left custom-width" *ngIf="!hide">
                            <label for="website" class="label-required display"> Product Group</label>
                            <p-autoComplete formControlName="ProductGroupName" [dropdown]="true"
                                [suggestions]="filterProductGroups" [forceSelection]="true"
                                (completeMethod)="filterProductGroup($event)" (onSelect)="setProductGroups($event)"
                                field="productGroupName" placeholder="Search Product Group" styleClass="w-full"
                                [ngClass]="{
                                                            'ng-invalid ng-dirty': submitted && !createProductForm.controls.ProductGroupName.value
                                                        }" (keydown.enter)="focusNextInput($event)">
                                <ng-template let-item pTemplate="item">
                                    <span>{{ item.productGroupName }}</span>
                                </ng-template>
                            </p-autoComplete>

                            <!-- <small *ngIf="submitted && formControls.UnitsOfMeasure.errors" id="name-error" class="text-red-500">Required field.</small> -->
                        </div>
                        <div class="field text-left mt-4 custom-width" *ngIf="!hide">
                            <label for="tags">Product Category</label>
                            <p-autoComplete formControlName="CategoryValue" [dropdown]="true"
                                (onSelect)="setCategory($event)" (completeMethod)="filtersCatagory($event)"
                                [suggestions]="filterCategorys" field="categoryName" placeholder="Select Category"
                                styleClass="w-full">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.categoryCode}} - {{item.categoryName}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <!-- <small *ngIf="submitted && formControls.CategoryValue.errors" id="name-error"
                                class="text-red-500">Required field.</small> -->
                        </div>
                        <div class="field text-left custom-width" *ngIf="!hide">
                            <label for="website"> Product SubCategory</label>

                            <p-autoComplete formControlName="SubCategoryName" [dropdown]="true"
                                (onSelect)="setProductSubCategory($event)" [suggestions]="filterCategorys"
                                (completeMethod)="filterSubCategory($event)" field="SubCategoryName"
                                placeholder="Search SubCategory" styleClass="w-full"
                                (keydown.enter)="focusNextInput($event)">
                                <ng-template let-item pTemplate="item">
                                    <span>{{ item.subCategoryName }}</span>
                                </ng-template>
                            </p-autoComplete>


                        </div>
                    </div>

                    <div class="col">
                        <div class="field text-left mt-1">
                            <label for="Vendor">Primary Vendor</label>
                            <div class="p-inputgroup p-lookup">
                                <input pInputText formControlName="VendorName" readonly
                                    styleClass="w-full p-inputtext-sm" placeholder="Search"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.VendorName.errors}" />
                                <button type="button" [disabled]="product.length > 0" pButton pRipple severity="info"
                                    icon="pi pi-search" (click)="getVendor()">
                                </button>
                            </div>
                        </div>
                        <div class="field" *ngIf="hide">
                            <label for="tags">Barcode</label><br>
                            <input formControlName="Barcode" type="number" readonly pInputText style="width:100%" />
                        </div>
                        <div class="field text-left" *ngIf="!hide">
                            <label for="website">Vendor Product Code</label>
                            <input pInputText formControlName="VendorProductCode"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ProductName.errors }"
                                class="w-full"
                                style="padding: 2px 4px; font-size: 12px; height: 35px; line-height: 1;" />
                        </div>

                        <div class="field text-left mt-1 custom-width" *ngIf="!hide">
                            <label for="tags">Standard Type</label>
                            <p-autoComplete formControlName="StandardType" [dropdown]="true"
                                (onSelect)="setstandardtype($event)" (completeMethod)="filterstandardtype($event)"
                                [suggestions]="filterStandardtype" field="StandardType"
                                placeholder="Select Standard Type" styleClass="w-full"
                                [ngClass]="{ 'ng-invalid ng-dirty': submitted && createProductForm.controls['StandardType'].invalid }">

                                <ng-template let-item pTemplate="item">
                                    <span>{{ item.StandardType }}</span>
                                </ng-template>
                            </p-autoComplete>

                        </div>


                    </div>

                </div>
            </p-tabPanel>

        </p-tabView>
    </form>
</p-card>

<p-toast></p-toast>